import { addDays, isWeekend } from 'date-fns'

/**
 * Returns the next business day (Monday–Friday), skipping weekends. The time for the next business day is set to 12am
 * @param date The reference date
 * @returns The next business day
 */
export function getNextBusinessDay(date: Date): Date {
  let nextDay = addDays(date, 1)
  while (isWeekend(nextDay)) {
    nextDay = addDays(nextDay, 1)
  }
  return new Date(nextDay.setHours(0, 0, 0, 0))
}
